import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.ass-specific setting previously selected.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class WritingDeletionPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("WritingDeletionPreference");
	}

	onWritingDeletionChange(value) {
		var prefsHash = { allow_student_writing_deletion: value }
		this.props.onChange(prefsHash, "You successfully changed the writing deletion setting.");
	}

	render() {
		return (
			<div>
				<p>Control whether your students can delete their previous answers, reviews, or quizzes.</p>
				<div className="viewableScoreOptions">
					<label>
						<input type="radio" onChange={ this.onWritingDeletionChange.bind(this, true) }
							checked={ this.props.prefs.allow_student_writing_deletion === true } />
						Allow students to delete their written responses
					</label><br />
					<label>
						<input type="radio" onChange={ this.onWritingDeletionChange.bind(this, false) }
							checked={ this.props.prefs.allow_student_writing_deletion === false } />
						Do not allow students to delete their written responses
					</label>
				</div>
			</div>
		)
	}
}

WritingDeletionPreference.WrappedComponent.propTypes = StrictPropTypes({
	prefs: PropTypes.object.isRequired,
	// Handlers from @connect
	onChange: PropTypes.func.isRequired,
	populateData: PropTypes.func.isRequired

});

module.exports = WritingDeletionPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/WritingDeletionPreference.js